import { gsap, TweenMax, TweenLite, DrawSVGPlugin, ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, TweenMax, TweenLite, DrawSVGPlugin);

// Trigger header on scroll
gsap.to('.menuDesktop', { 
  duration: 0.2,
  scrollTrigger: {
    start: 'top -80',
    end: 99999,
    toggleActions: 'play none none reverse',
    toggleClass: {className: 'scrolled', targets: 'header.wp-block-template-part'},
  },
});

// Change URL quote link products
$('a.requestquote').each(function(){ 
  var oldUrl = $(this).attr('href');
  var newUrl = oldUrl.replace(oldUrl, oldUrl + '#quote');
  $(this).attr('href', newUrl);
});

// Play video if exist viewport
$(window).scroll(function () {
  const viewportBottom = window.scrollY + window.innerHeight;
  $('video').each(function () {
    if ($(this).offset().top + $(this).height() < window.scrollY) {
      $(this)[0].pause();
    } else if ($(this).offset().top < viewportBottom) {
      $(this)[0].play();
    }
  });
});

// Lijnen
function animatielijnen(){
  var lijnen = document.querySelectorAll('.st10');
  [].forEach.call(lijnen, function(path) {
    var length = path.getTotalLength();
    path.style.transition = path.style.WebkitTransition = 'none';
    path.style.strokeDasharray = length + ' ' + length;
    path.style.strokeDashoffset = length;
    path.getBoundingClientRect();
    path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out';
    path.style.strokeDashoffset = '0';
  })
}
gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray('.is-style-indrukwekkend-lijnenspel').forEach(element => {
  gsap.to(element, {
    scrollTrigger: {
    trigger: element,
    onEnter: animatielijnen, 
    once: true,
    },
  })
});

// Logo animation
var paths = document.querySelectorAll('.st3');
[].forEach.call(paths, function(path) {
  var length = path.getTotalLength();
  path.style.transition = path.style.WebkitTransition = 'none';
  path.style.strokeDasharray = length + ' ' + length;
  path.style.strokeDashoffset = length;
  path.getBoundingClientRect();
  path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out';
  path.style.strokeDashoffset = '0';
})

// Media-text block
gsap.utils.toArray('.wp-block-media-text').forEach(function(elem) {
  let figure= elem.querySelector('figure');
  let content = elem.querySelector('.wp-block-media-text__content');
  hide(figure);
  hide(content);
  ScrollTrigger.create({
    trigger: elem,
    once: true,
    start: 'top bottom-=100',
    onEnter: function() { animateFrom(elem) }, 
    onEnterBack: function() { animateFrom(elem, -1) },
  });
});

// HR
document.querySelectorAll('.hr').forEach((hr) => {
  const q = gsap.utils.selector(hr);
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: hr,
      start: 'top bottom-=10%',
      end: 'bottom bottom-=10%',
      markers: false,
    },
  });
  tl.from(q('.animate'), {
    drawSVG: '0%',
    duration: 1.2,
    ease: 'power1.inOut',
  });
  tl.from(
    q('.animateright'),
    {
      drawSVG: '100% 100%',
      duration: 1.2,
      ease: 'power1.inOut',
    },
    '<'
  );

  tl.from(q('.vert'), {
    drawSVG: '50% 50%',
    ease: 'power1.inOut',
  });

  tl.from(
    q('.vert2'),
    {
      drawSVG: '50% 50%',
      ease: 'power1.inOut',
    },
    '<'
  );
});

// Header + text
gsap.utils.toArray('.wp-block-cover').forEach(function(elem) {
  let figure= elem.querySelector('.wp-block-cover__image-background');
  let title = elem.querySelector('.wp-block-cover__inner-container h1');
  // let text = elem.querySelector('.wp-block-cover__inner-container .wp-block-buttons');
  let tl = gsap.timeline({defaults: {ease: 'power4.inOut', duration: 1.5 }})
  tl.from(figure, { autoAlpha: 0, duration: 0, size: 100, ease: 'Expo.EaseOut'})
  //   // .from(title, {autoAlpha: 0, y: 30}, '<') // deze levert zo een "flits" op omdat de JS later geladen wordt dan de content.
  //   .from(text, {autoAlpha: 0, y: 30}, '<+=0.2')
  tl.fromTo(title, { opacity: 0, y: 30 }, { opacity: 1, y: 0 });
  tl.pause();

  ScrollTrigger.create({
    trigger: elem,
    start: 'top bottom-=50%',
    onEnter: function() { tl.resume(); }, 
  });
});

// Search
var button = document.querySelector('div.search-icon');
var tween = TweenLite.from('header .wp-block-search', 0.3, {y:-100, opacity:0});
var icon = TweenMax.set(button, { css:{ className:'search-icon active' } });
tween.reverse();
icon.reverse();

if (typeof button !== 'undefined' && button !== null) {
  // the variable is defined
  button.onclick = function() {
    tween.reversed(!tween.reversed());
    icon.reversed(!icon.reversed());
  }
}

// Animate functions
function animateFrom(elem, direction) {
  direction = direction | 1;
  var x = 0,
      y = direction * 0;
  if(elem.classList.contains('has-media-on-the-right')) {
    x = 0;
    y = 0;
  } else {
    x = 0;
    y = 0;
  }
  let figure= elem.querySelector('figure');
  gsap.fromTo(figure, {x: x, y: y, autoAlpha: 0}, {
    duration: 7.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
  let content = elem.querySelector('.wp-block-media-text__content');
  x = 0,
  y = direction * 0;
  gsap.fromTo(content, {x: x, y: y, autoAlpha: 0}, {
    duration: 7.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
}
function hide(elem) {
  gsap.set(elem, {autoAlpha: 0});
}

// Tabs download
document.addEventListener('DOMContentLoaded', function() {
  const tabLinks = document.querySelectorAll('.tab-link');
  const tabPanes = document.querySelectorAll('.tab-pane');
  tabLinks.forEach(button => {
    button.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      tabLinks.forEach(btn => btn.classList.remove('active'));
      tabPanes.forEach(pane => pane.style.display = 'none');
      this.classList.add('active');
      document.getElementById(targetTab).style.display = 'block';
    });
  });
  if (tabLinks.length > 0) {
    tabLinks[0].click();
  }
});
